export function getSkuNumber(sku?: string | null): number {
  if (!sku) return 0;
  const match = sku.match(/\d+$/);
  if (!match) return 0;
  return parseInt(match[0], 10);
}